import React, { useState, useEffect, useContext } from "react";
import { AppContext } from "../../../context/AppContext";
import Cookies from "js-cookie";
// import { message } from "antd";
import "./index.css";

const TaskFlowTab = ({ selectedEmp }) => {
  const { employee } = useContext(AppContext);
  const [selectedCard, setSelectedCard] = useState(null);
  const [currentCardIndex, setCurrentCardIndex] = useState(-1);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [callHistory, setCallHistory] = useState({});
  const [remarksData, setRemarksData] = useState([]); // Added for remarks data
  const [activeTab, setActiveTab] = useState("form");

  const [formData, setFormData] = useState({
    studentId: "",
    studentName: "",
    studentPhone: "",
    followUpDate: "",
    callStatus: "Yet to Contact",
    callRemarks: "",
    remarkStatus: "general",
  });

  const [cards, setCards] = useState([]);
  const [pageByStage, setPageByStage] = useState({});

  const stages = [
    { id: "Yet to Contact", title: "Yet to Contact", color: "#6899f9ff" },
    { id: "not-answering", title: "Not Answering", color: "#f7ce49ff" },
    { id: "not-interested", title: "Not Interested", color: "#ff7681ff" },
    { id: "willing-to-join", title: "Willing to Join", color: "#6cff8fff" },
    { id: "follow-up", title: "Follow-up", color: "#6cb5f5ff" },
    { id: "priority", title: "Prime Leads", color: "#bc79fbff" },
    { id: "joined", title: "Joined", color: "#84e2f3ff" },
  ];

  const CARDS_PER_PAGE = 10;

  useEffect(() => {
    fetchCards();
  }, [selectedEmp]);

  const fetchCards = async () => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}/get-students`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            Authorization: `Bearer ${Cookies.get("akt")}`,
          },
          body: JSON.stringify({
            employee: employee?.admin ? selectedEmp : employee.email,
          }),
        },
      );

      const resp = await response.json();
      const normalized = (resp.data || []).map((item, idx) => ({
        key: item.studentId || item.id || idx,
        ...item,
      }));
      setCards(normalized);
    } catch (err) {
      console.error("Fetch error:", err);
    }
  };

  const getRemarks = async (studentId) => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}/get-remarks`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            Authorization: `Bearer ${Cookies.get("akt")}`,
          },
          body: JSON.stringify({ studentId }),
        },
      );
      const result = await response.json();
      if (!response.ok) {
        throw new Error(result.message || "Failed to fetch remarks");
      }

      setRemarksData(result.data);
    } catch (error) {
      console.error("Error fetching remarks:", error);
      return [];
    }
  };

  // Update student status and add remark
  const updateStudentStatus = async () => {
    const studentId = formData.studentId;
    const status = formData.callStatus;
    const remark = formData.remarks || "";
    try {
      // First, update the student status
      const updateResponse = await fetch(
        `${process.env.REACT_APP_BASE_URL}/calls/update/${studentId}`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            Authorization: `Bearer ${Cookies.get("akt")}`,
          },
          body: JSON.stringify({
            status,
            remark,
          }),
        },
      );

      if (!updateResponse.ok) {
        throw new Error("Failed to update student status");
      }

      // If there's a remark, add it
      // if (remark && remark.trim() !== "") {
      //   await fetch(`${process.env.REACT_APP_BASE_URL}/remarks/add`, {
      //     method: "POST",
      //     headers: {
      //       "Content-Type": "application/json",
      //       Accept: "application/json",
      //       Authorization: `Bearer ${Cookies.get("akt")}`,
      //     },
      //     body: JSON.stringify({
      //       studentId: studentId,
      //       content: remark,
      //       author: employee.email || "Agent",
      //       type: "Status Update",
      //       status: status,
      //     }),
      //   });
      // }

      // Refresh the cards list
      // await fetchCards();

      // Refresh remarks for the current student if modal is open
      // if (selectedCard && selectedCard.id === studentId) {
      //   await fetchRemarks(studentId);
      // }

      return true;
    } catch (error) {
      console.error("Update error:", error);
      return false;
    }
  };

  const handleAddRemark = async () => {
    const remarkText = formData.callRemarks;
    if (!remarkText.trim()) {
      alert("Remark cannot be empty!");
      return;
    }

    // setLoading(true);

    try {
      const timestamp = new Date().toISOString();
      const newRemark = {
        studentId: formData.studentId,
        remark: formData.remarkStatus,
        content: remarkText,
        type: formData.remarkType,
        datetime: timestamp,
        date: timestamp,
        author: employee.name, // In a real app, this would come from auth context
      };

      const res = await fetch(`${process.env.REACT_APP_BASE_URL}/remarks`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: `Bearer ${Cookies.get("akt")}`,
        },
        body: JSON.stringify(newRemark),
      });

      if (!res.ok) {
        throw new Error("Failed to update remark");
      }

      alert("Remark added successfully!");
    } catch (error) {
      alert("Failed to add remark. Please try again.");
    }
  };

  const changePage = (stageId, newPage, totalPages) => {
    if (newPage < 1 || newPage > totalPages) return;

    setPageByStage((prev) => ({
      ...prev,
      [stageId]: newPage,
    }));
  };

  const getStatusColor = (status) => {
    const colorMap = {
      "Yet to Contact": "#e2e3e5",
      "not-answering": "#fff3cd",
      "not-interested": "#f8d7da",
      "willing-to-join": "#d4edda", // Fixed from "ready-to-join" to "willing-to-join"
      "follow-up": "#cce7ff",
      priority: "#e6ccff",
      joined: "#d1ecf1",
    };
    return colorMap[status] || "#e2e3e5";
  };

  const handleCardClick = async (card, index) => {
    setSelectedCard(card);
    setCurrentCardIndex(index);
    setFormData({
      studentId: card.id || card.studentId,
      studentName: card.name || card.studentName,
      studentPhone: card.phone || card.studentPhone,
      callStatus: card.status || "Yet to Contact",
      followUpDate: "",
      callRemarks: "",
      remarkStatus: "general",
    });

    // Fetch remarks for this student
    // await fetchRemarks(card.id || card.studentId);
    setIsModalOpen(true);
  };

  const handlePrevCard = () => {
    if (currentCardIndex > 0 && cards.length > 0) {
      const prevIndex = currentCardIndex - 1;
      handleCardClick(cards[prevIndex], prevIndex);
    }
  };

  const handleNextCard = () => {
    if (currentCardIndex < cards.length - 1 && cards.length > 0) {
      const nextIndex = currentCardIndex + 1;
      handleCardClick(cards[nextIndex], nextIndex);
    }
  };

  const handleFormChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleFormSubmit = async (e) => {
    e.preventDefault();

    if (!formData.studentId) {
      console.error("No student ID selected");
      return;
    }

    // Update student status and add remark
    const success = await updateStudentStatus(
      formData.studentId,
      formData.callStatus,
      formData.callRemarks,
    );

    if (success) {
      updateStudentStatus();
      handleAddRemark();
      getRemarks();

      // Update local state
      const updatedCards = cards.map((card) => {
        if ((card.id || card.studentId) === formData.studentId) {
          return {
            ...card,
            status: formData.callStatus,
          };
        }
        return card;
      });

      setCards(updatedCards);

      // Update call history locally
      const newCallRecord = {
        date: new Date().toISOString().split("T")[0],
        status: formData.callStatus,
        remarks: formData.callRemarks,
        followUpDate: formData.followUpDate,
      };

      setCallHistory((prev) => ({
        ...prev,
        [formData.studentId]: [
          ...(prev[formData.studentId] || []),
          newCallRecord,
        ],
      }));

      // Reset form
      setFormData({
        ...formData,
        callRemarks: "",
        remarkStatus: "general",
        followUpDate: "",
      });

      // Show success message
      // alert("Status updated successfully!");
    } else {
      // alert("Failed to update status");
    }
  };

  const getCardsByStatus = (status) => {
    return cards.filter((card) => (card.status || "Yet to Contact") === status);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setSelectedCard(null);
    setRemarksData([]);
  };

  return (
    <div className="task-flow-container">
      {/* Navigation Bar */}
      <h1 className="task-flow-heading">My Task-Flow</h1>
      {/* Kanban Board */}
      <div className="kanban-board">
        {stages.map((stage) => {
          const stageCards = getCardsByStatus(stage.id);
          const totalPages = Math.ceil(stageCards.length / CARDS_PER_PAGE);
          const currentPage = pageByStage[stage.id] || 1;
          const startIndex = (currentPage - 1) * CARDS_PER_PAGE;
          const paginatedCards = stageCards.slice(
            startIndex,
            startIndex + CARDS_PER_PAGE,
          );

          const visiblePages = [];
          const maxButtons = 4;
          let start = Math.max(1, currentPage - 1);
          let end = Math.min(totalPages, start + maxButtons - 1);

          if (end - start < maxButtons - 1) {
            start = Math.max(1, end - maxButtons + 1);
          }

          for (let i = start; i <= end; i++) {
            visiblePages.push(i);
          }

          return (
            <div key={stage.id} className="stage-column" data-status={stage.id}>
              <div
                className="stage-header"
                style={{ backgroundColor: stage.color }}
              >
                {stage.title}
                <span className="stage-count">{stageCards.length}</span>
              </div>

              {/* Render Cards */}
              {paginatedCards.map((card) => (
                <div
                  key={card.key || card.id || card.studentId}
                  className="student-card"
                  onClick={() => {
                    const index = cards.findIndex(
                      (c) =>
                        (c.id || c.studentId) === (card.id || card.studentId),
                    );
                    handleCardClick(card, index);

                    console.log(stage.id);

                    getRemarks(card.studentId);
                  }}
                  // style={{
                  //   borderLeftColor: stage.color,
                  //   backgroundColor: getStatusColor(
                  //     card.status || "Yet to Contact"
                  //   ),
                  // }}
                >
                  <div className="card-header">
                    <span className="student-id">
                      {card.studentId || card.id}
                    </span>
                    <div className="student-name">
                      {card.name || card.studentName}
                    </div>
                  </div>
                  {/* <div className="card-footer">{getCardFooterText(card)}</div> */}
                </div>
              ))}

              {/* Pagination */}
              {totalPages > 1 && (
                <div className="pagination">
                  <button
                    className="page-btn"
                    onClick={() =>
                      changePage(stage.id, currentPage - 1, totalPages)
                    }
                    disabled={currentPage === 1}
                  >
                    Prev
                  </button>

                  {visiblePages.map((page) => (
                    <button
                      key={page}
                      className={`page-btn ${
                        page === currentPage ? "active" : ""
                      }`}
                      onClick={() => changePage(stage.id, page, totalPages)}
                    >
                      {page}
                    </button>
                  ))}

                  <button
                    className="page-btn"
                    onClick={() =>
                      changePage(stage.id, currentPage + 1, totalPages)
                    }
                    disabled={currentPage === totalPages}
                  >
                    Next
                  </button>
                </div>
              )}
            </div>
          );
        })}
      </div>

      {/* Card Details Modal */}
      {isModalOpen && selectedCard && (
        <div className="modal active" onClick={closeModal}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            {/* Modal Header */}
            <div className="modal-header">
              <h2>Update Call Status</h2>
              <span className="close-modal" onClick={closeModal}>
                &times;
              </span>
            </div>

            {/* TAB BUTTONS */}
            <div className="modal-tabs">
              <button
                className={`modal-tab-btn ${
                  activeTab === "form" ? "active" : ""
                }`}
                onClick={() => setActiveTab("form")}
              >
                Update Form
              </button>

              <button
                className={`modal-tab-btn ${
                  activeTab === "remarks" ? "active" : ""
                }`}
                onClick={() => setActiveTab("remarks")}
              >
                Remarks History
              </button>
            </div>

            <div className="modal-body">
              {/* TAB 1 – FORM */}
              {activeTab === "form" && (
                <form id="call-update-form" onSubmit={handleFormSubmit}>
                  <input
                    type="hidden"
                    name="studentId"
                    value={formData.studentId}
                  />

                  <div className="form-group">
                    <label>Student Name</label>
                    <input
                      type="text"
                      className="form-control"
                      value={formData.studentName}
                      readOnly
                    />
                  </div>

                  <div className="form-group">
                    <label>Phone Number</label>
                    <input
                      type="text"
                      className="form-control"
                      value={formData.studentPhone}
                      readOnly
                    />
                  </div>

                  <div className="form-group">
                    <label>Follow-up Date</label>
                    <input
                      type="date"
                      name="followUpDate"
                      className="form-control"
                      value={formData.followUpDate}
                      onChange={handleFormChange}
                    />
                  </div>

                  <div className="form-group">
                    <label>Call Status</label>
                    <select
                      name="callStatus"
                      className="form-control"
                      value={formData.callStatus}
                      onChange={handleFormChange}
                    >
                      <option value="not-answering">Not Answering</option>
                      <option value="not-interested">Not Interested</option>
                      <option value="willing-to-join">Willing to Join</option>
                      <option value="follow-up">Follow-up</option>
                      <option value="priority">Prime Leads</option>
                      <option value="joined">Joined</option>
                    </select>
                  </div>

                  <div className="form-group">
                    <label>Call Remarks</label>
                    <textarea
                      name="callRemarks"
                      className="form-control"
                      placeholder="Enter call remarks..."
                      value={formData.callRemarks}
                      onChange={handleFormChange}
                      rows="3"
                    />
                  </div>

                  <div className="form-group">
                    <label>Remarks Status</label>
                    <select
                      name="remarkStatus"
                      className="form-control"
                      value={formData.remarkStatus}
                      onChange={handleFormChange}
                    >
                      <option value="callback">Call Back</option>
                      <option value="not-answering">Not Answering</option>
                      <option value="follow-up">Follow Up Needed</option>
                      <option value="interested">Interested</option>
                      <option value="not-interested">Not Interested</option>
                      <option value="priority-call">Priority Call</option>
                      <option value="others">Others</option>
                    </select>
                  </div>

                  <button type="submit" className="btn btn-success">
                    Update Status
                  </button>
                </form>
              )}

              {/* TAB 2 – REMARKS HISTORY */}
              {activeTab === "remarks" && remarksData.length > 0 && (
                <div className="remarks-history">
                  <h3 className="rms-title">Previous Remarks</h3>

                  <div className="rms-list">
                    {[...remarksData[0].remarks]
                      .reverse()
                      .map((remark, index) => (
                        <div key={index} className="rms-item">
                          <div className="rms-header">
                            <strong className="rms-author">
                              {remark.author || "hello"}
                            </strong>

                            <div className="rms-status">
                              Status: {remark.remark} <br />
                              <span className="rms-date">
                                {new Date(remark.datetime).toLocaleDateString()}
                              </span>
                            </div>
                          </div>

                          <div className="rms-content">{remark.content}</div>
                        </div>
                      ))}
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default TaskFlowTab;
